import { useEffect } from "react"
import { Grid, TextField, Button, MenuItem, Select, FormControl, InputLabel } from "@material-ui/core";
import * as yup from "yup";
import { useFormik } from "formik";
import { phoneRegexOnlyDgit } from "../../../utils/yupCustomShema";
import { useDispatch, useSelector } from "react-redux";
import { ToastMessage } from "../../../global/ToastMessage";
import {
    newClienteCtoizacionAction,
    obtenerClientesCotizadorAllAction,
    obtenerClientesCotizadorAction,
    targetClienteAction,
    updateClienteCtoizacionAction,
    openModalRegistroClienteAction
} from "../../../ducks/cotizadorDuck";
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck";
import { InitialValueCliente } from "../InitialCliente";
import { CatLada } from "../../../utils/CatLada";
import { DialogMessage } from "../../../global/DialogMessage";
const validationSchema = yup.object({
    nombre: yup.string("Ingresa un nombre").required("Nombre es requerido"),
    apellidop: yup.string("Ingresa un apellido paterno").optional(),
    apellidom: yup.string("Ingresa un apellido materno").optional(),
    telefono: yup
        .string("Ingresa un telefono")
        .matches(phoneRegexOnlyDgit, "Número de teléfono inválido")
        .required("Teléfono es requerido"),
    correo: yup
        .string("Ingresa un email")
        .email("Email inválido")
        .required("Email es requerido"),
});

const InitalValues = {
    nombre: "",
    apellidop: "",
    apellidom: "",
    telefono: "",
    correo: "",
    lada: "+52",
};


const Form = () => {
    const { editar, cliente } = useSelector((store) => store.cotizador)
    const dispatch = useDispatch()
    const formik = useFormik({
        initialValues: InitalValues,
        validationSchema: validationSchema,
        onSubmit: (values) => handleSubmit(values),
    })
    const handleSubmit = (values) => {
        const fullPhoneNumber = `${values.lada}${values.telefono}`;
        let payload = {
            Nombre: `${values.nombre} ${values.apellidop} ${values.apellidom}`,
            EMail: values.correo,
            Telefono: fullPhoneNumber,
        };
    
        DialogMessage.fire({
            html: `
                <p><strong>Nombre:</strong> ${payload.Nombre}</p>
                <p><strong>Email:</strong> ${payload.EMail}</p>
                <p><strong>Teléfono:</strong> ${payload.Telefono}</p>
            `,
            icon: "info",
            showCancelButton: true,
            confirmButtonText: "Confirmar y enviar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "" }));
                if (editar) {
                    payload.idCliente = cliente.IdCliente;
                    dispatch(updateClienteCtoizacionAction(payload)).then((response) => {
                        dispatch(offLoadAction());
                        handleResponse(response);
                    });
                } else {
                    dispatch(newClienteCtoizacionAction(payload)).then((response) => {
                        dispatch(offLoadAction());
                        handleResponse(response);
                    });
                }
            }
        })
    }
    const handleResponse = (response) => {
        if (response.status === 500 || response.status === 400) {
            ToastMessage.fire({
                icon: "error",
                title: response.Message || "Ha habido un problema, intenta más tarde.",
            })
            return
        }
        clearForm();
        ToastMessage.fire({
            icon: "success",
            title: "Ingreso Correcto",
        })
    }
    const clearForm = () => {
        formik.resetForm(InitalValues)
        dispatch(obtenerClientesCotizadorAction())
        dispatch(obtenerClientesCotizadorAllAction())
        dispatch(openModalRegistroClienteAction({ open: false }))
        dispatch(targetClienteAction({ cliente: InitialValueCliente, editar: false, vista: 1 }))
    }
    useEffect(() => {
        if (editar) {
            const nameSplit = cliente.Nombre?.split(" ") || [];
            formik.setFieldValue("nombre", nameSplit[0] || "");
            formik.setFieldValue("apellidop", nameSplit[1] || "");
            formik.setFieldValue("apellidom", nameSplit[2] || "");
            formik.setFieldValue("telefono", cliente?.Telefono?.slice(3) || "");
            formik.setFieldValue("lada", cliente?.Telefono?.slice(0, 3) || "+52");
            formik.setFieldValue("correo", cliente?.EMail || "");
        } else {
            formik.resetForm(InitalValues);
        }
    }, [editar, cliente.IdCliente]); //eslint-disable-line

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
                {/* <Grid item xs={12}>
                    <h4>{editar ? "Editar cliente" : "Nuevo cliente"}</h4>
                </Grid> */}

                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Nombre"
                        name="nombre"
                        variant="outlined"
                        value={formik.values.nombre}
                        onChange={formik.handleChange}
                        error={formik.touched.nombre && Boolean(formik.errors.nombre)}
                        helperText={formik.touched.nombre && formik.errors.nombre}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Apellido Paterno"
                        name="apellidop"
                        variant="outlined"
                        value={formik.values.apellidop}
                        onChange={formik.handleChange}
                        error={formik.touched.apellidop && Boolean(formik.errors.apellidop)}
                        helperText={formik.touched.apellidop && formik.errors.apellidop}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Apellido Materno"
                        name="apellidom"
                        variant="outlined"
                        value={formik.values.apellidom}
                        onChange={formik.handleChange}
                        error={formik.touched.apellidom && Boolean(formik.errors.apellidom)}
                        helperText={formik.touched.apellidom && formik.errors.apellidom}
                    />
                </Grid>
                {/* Teléfono con Lada */}
                <Grid item xs={4}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel id="lada-label">Lada</InputLabel>
                        <Select
                            labelId="lada-label"
                            id="lada"
                            name="lada"
                            value={formik.values.lada}
                            onChange={formik.handleChange}
                            label="Lada"
                        >
                            {CatLada.map((lada) => (
                                <MenuItem key={lada.lada} value={lada.lada}>
                                    {lada.name} ({lada.lada})
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={8}>
                    <TextField
                        fullWidth
                        label="Teléfono"
                        name="telefono"
                        variant="outlined"
                        value={formik.values.telefono}
                        onChange={formik.handleChange}
                        error={formik.touched.telefono && Boolean(formik.errors.telefono)}
                        helperText={formik.touched.telefono && formik.errors.telefono}
                    />
                </Grid>
                {/* Fin Teléfono con Lada */}
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Correo"
                        name="correo"
                        variant="outlined"
                        value={formik.values.correo}
                        onChange={formik.handleChange}
                        error={formik.touched.correo && Boolean(formik.errors.correo)}
                        helperText={formik.touched.correo && formik.errors.correo}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Button variant="contained" color="primary" type="submit">
                        Guardar
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
};

export default Form;
